module.exports = __webpack_public_path__ + "img/Groupe 530.22003b06.svg";